import i18n, { type Lang } from "@/i18n";
import { glossaryEntryBySlug } from "@/lib/glossary";
import { glossaryTermNlPath, SLUGS } from "@/lib/route-slugs";
import { localizedUrl, pageHead } from "@/lib/seo";

/** Head-metadata voor één woordenlijst-term in een taal. */
export function glossaryTermHead(slug: string, lang: Lang) {
  const entry = glossaryEntryBySlug(slug);
  const t = i18n.getFixedT(lang, "home");
  const tc = i18n.getFixedT(lang, "common");
  const setName = tc("glossary_page.title") as unknown as string;

  if (!entry) {
    return {
      ...pageHead({
        lang,
        pathWithoutLang: SLUGS.woordenlijst.nl,
        title: `${tc("glossary_page.term_not_found_title")} | IT Solutions`,
        description: tc("glossary_page.term_not_found_body") as unknown as string,
      }),
      meta: [
        { title: `${tc("glossary_page.term_not_found_title")} | IT Solutions` },
        { name: "robots", content: "noindex" },
      ],
    };
  }

  const title = t(entry.titleKey) as unknown as string;
  const description = (t(entry.introKey) as unknown as string).slice(0, 300);
  const pathWithoutLang = glossaryTermNlPath(slug);

  return pageHead({
    lang,
    pathWithoutLang,
    title: `${title} | ${setName} — IT Solutions`,
    description,
    ogType: "article",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "DefinedTerm",
      "@id": `${localizedUrl(pathWithoutLang, lang)}#term`,
      name: title,
      description,
      url: localizedUrl(pathWithoutLang, lang),
      inDefinedTermSet: {
        "@type": "DefinedTermSet",
        name: setName,
        url: localizedUrl(SLUGS.woordenlijst.nl, lang),
      },
    },
  });
}